import React from "react";
import { SurveyReportDataSet } from '../../../../../../amorg-common';
import { Survey } from '../../../../../../amorg-common';
import { RadialPctChart } from "../../../../../../designSystem/graphs/RadialPctChart";
import { H3 } from "../../../../../../designSystem/typography/Heading";
import { colors } from "../../../../../../designSystem/colors/color";
import { SegmentRatioBar } from "../../../../../../designSystem/graphs/SegmentRatioBar";
import { Em } from "../../../../../../designSystem/typography/Em";
import { txt } from "../../../../../../txt";
import { PageSection } from "../../../../../../designSystem/PageSection";


type SimpleReportSummarySectionProps = {
    survey: Survey,
    data: SurveyReportDataSet,
    expandable?:boolean
}
export function SimpleReportSummarySection(props: SimpleReportSummarySectionProps): JSX.Element 
{
    const allQuestionData = props.data.themeData.flatMap(t => t.questions);

    const answers = allQuestionData.length > 0
        ? allQuestionData[0].stats.totalSelections
        : 0;

    function format(value: number)
    {
        return parseFloat(value.toFixed(1));
    }

    return (
        <div>
            <PageSection headerStyleVariant="card" contentStyleVariant="card"
                header={{
                    title: 'Resultat for undersøgelsen',
                    defaultCollapsed: false,
                }}>
                    <div>
                        <H3>
                            {answers === 0 
                                ? <><Em>Ingen</Em> besvarelser</> 
                                : <><Em>{answers}</Em> besvarelser med en gennemsnitlig score på <Em>{props.data.stats.score.agreePlusPct.toFixed(0)}%</Em></>
                            }
                        </H3>
                    </div>
                    <div style={{display:'flex', gap:'20px', alignItems:'center', marginTop:'10px'}}>
                        <RadialPctChart pct={props.data.stats.score.agreePlusPct} />
                        <div style={{flexGrow:1}}>
                            {/* <AnswerRatioVerticalGraph summaryStats={aggregatedSelections} /> */}

                            <SegmentRatioBar legend heightPx={16}
                                data={[
                                    { value: format(props.data.stats.score.summary.score1Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score1, legendText:txt.SurveyScore_1 },
                                    { value: format(props.data.stats.score.summary.score2Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score2, legendText:txt.SurveyScore_2 },
                                    { value: format(props.data.stats.score.summary.score3Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score3, legendText:txt.SurveyScore_3 },
                                    { value: format(props.data.stats.score.summary.score4Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score4, legendText:txt.SurveyScore_4 },
                                    { value: format(props.data.stats.score.summary.score5Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score5, legendText:txt.SurveyScore_5 }
                                ]}
                            />

                        </div>
                        {/* <SelectionStatsGraphics stats={aggregatedSelections} /> */}
                    </div>
            </PageSection>
        </div>
    )
}